// pages/Dashboard.jsx
import About from "../components/aboutComponents/About";
import HomeLayout from "../components/HomeLayout";

export default function AboutPage() {
  return (
    <HomeLayout>
      <About />
    </HomeLayout>
  );
}
